export default __webpack_public_path__ + "static/media/desktop.85c3c2f0.png";